// FavouriteButton.jsx
import React, { useEffect, useMemo, useState } from "react";
import { getFirestore, doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import StarIcon from "./assets/star-icon.png";
import StarIconActive from "./assets/star-icon-active.png";

const FavouriteButton = ({ pageUrl }) => {
  const [uid, setUid] = useState(null);
  const [isFavourited, setIsFavourited] = useState(false);
  const [loading, setLoading] = useState(true);

  const auth = getAuth();
  const db = getFirestore();
  const targetUrl = useMemo(() => pageUrl || window.location.pathname, [pageUrl]);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) { setUid(null); setIsFavourited(false); setLoading(false); return; }
      setUid(user.uid);
      try {
        const ref = doc(db, "users", user.uid);
        const snap = await getDoc(ref);
        const favs = snap.exists() ? (snap.data().favourites || []) : [];
        setIsFavourited(favs.includes(targetUrl));
      } finally {
        setLoading(false);
      }
    });
    return () => unsub();
  }, [auth, db, targetUrl]);

  const toggle = async () => {
    if (!uid) return;
    const ref = doc(db, "users", uid);
    // optimistic UI
    const next = !isFavourited;
    setIsFavourited(next);
    try {
      const snap = await getDoc(ref);
      if (!snap.exists()) {
        await setDoc(ref, { favourites: [targetUrl] }, { merge: true });
        return;
      }
      await updateDoc(ref, {
        favourites: next ? arrayUnion(targetUrl) : arrayRemove(targetUrl),
      });
    } catch (e) {
      console.error(e);
      setIsFavourited((v) => !v); // revert on failure
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={loading || !uid}
      style={{ background: "none", border: "none", display: "flex", alignItems: "center", color: "black", cursor: loading || !uid ? "not-allowed" : "pointer", opacity: loading || !uid ? 0.6 : 1 }}
      title={isFavourited ? "Remove from favourites" : "Add to favourites"}
    >
      <img src={isFavourited ? StarIconActive : StarIcon} alt="Favourite" style={{ width: 20, height: 20, marginRight: 8 }} />
      <span style={{ fontSize: 14 }}>{isFavourited ? "Favourited" : "Add to favourites"}</span>
    </button>
  );
};

export default FavouriteButton;
